module.exports = __webpack_public_path__ + "img/lg_ring_y_0_0_null@3x.9745706c.png";